document.addEventListener("collection:reloaded", function () {
  $(".delete-this-product").remove();
  if ($(".Tilgængelighed-value_1 input").is(":checked")) {
  } else {
    $(".Tilgængelighed-value_1 .tag__text").click();
  }
});
document.addEventListener("page:loaded", function () {
  // Page has loaded and theme assets are ready
  if ($(".Tilgængelighed-value_1 input").is(":checked")) {
  } else {
    $(".Tilgængelighed-value_1 .tag__text").click();
  }
});
